import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common/InspectionChecklist';

export const ProductVisualCheckList: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    return (
        <InspectionChecklist 
            {...props}
            defaultHeader="Product Visual Check"
            completionTranslationKey="product_visual_check"
        />
    );
};